module.exports = __webpack_public_path__ + "a0327da30df59c5657bcbed2fcf667ee.png";